import React from "react";
import NavLink from "react-router-dom/NavLink";

const NavBar = () => {
  return (
    <nav className="navigationBox">
      <h6 className="bestView">NOTE: Best View - Google Chrome (1920x1080) resolution</h6>
      <h5>Navigation</h5>
      <div id="navbarNav">
        <ul>
          <li className="nav-item active">
            <NavLink className="nav-link" to="/main">
              Main <span className="sr-only">(current)</span>
            </NavLink>
          </li>
          <li className="nav-item active">
            <NavLink className="nav-link" to="/main2">
              Main 2
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/language">
              Language
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/language2">
              Language2
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/reason">
              Reason
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/wardvisitor">
              Ward Visitor
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/generalregistration">
              General Entrance
            </NavLink>
          </li> 
          <li className="nav-item">
            <NavLink className="nav-link" to="/generalregistrationtwo">
              General Entrance 2
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/generalsummary">
              General Summary
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/wardregistration">
              Ward Registration
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/wardregistration2">
              Ward Registration 2
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/wardsummary">
              Ward Summary
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/wardsummary2">
              Ward Summary 2
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/successreg">
              Success Registration
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/successreg2">
              Success Registration 2
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/quotafull">
              Quota Full
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/accessdenied">
              Access Denied
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/emergencyalert">
              Emergency Alert
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/laneclosed">
              Lane Closed
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/exceeded">
              Exceeded Attempts
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/patientaway">
              Patient Away
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/apptregistration">
              Appointment Registration
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/apptsummary">
              Appointment Summary
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/wardregexist">
              Ward Registration Exist
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/generalquestion">
              General Questionnaires
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/generalquestiontwo">
              General Questionnaires Two
            </NavLink>
          </li>
          {/* <li className="nav-item">
            <NavLink className="nav-link" to="/keyboard">
              Test 
            </NavLink>
          </li>   */}
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;